import StepHeader from "./StepHeader";
import StepFooter from "./StepFooter";

export default function ToolsLayout({
	stepNumber,
	totalSteps,
	title,
	subtitle, // Add subtitle prop
	children,
	onBack,
	onPrev,
	onNext,
	projectId,
	projectName,
	projectVideoUrl, // Add this prop
	userName, // Add userName prop
}) {
	return (
		<div className="flex flex-col h-screen bg-[#fffef6] ">
			{/* Header */}
			<StepHeader
				stepNumber={stepNumber}
				totalSteps={totalSteps}
				title={title}
				subtitle={subtitle} // Pass subtitle to StepHeader
				onBack={onBack}
			/>

			{/* Middle Content */}
			<main className="mx-auto flex-1 w-full max-w-6xl overflow-y-auto p-4 lg:px-8 lg:py-6">{children}</main>

			{/* Footer */}
			<StepFooter 
				projectId={projectId}
				projectName={projectName}
				stepNumber={stepNumber}
				stepTitle={title}
				totalSteps={totalSteps}
				projectVideoUrl={projectVideoUrl}
				onPrev={onPrev} 
				onNext={onNext}
				userName={userName} // Pass userName prop
				isPrevDisabled={false} // Enable previous button to go back to overview
				isNextDisabled={false}
				isNextFinal={false}
			/>
		</div>
	);
}
